import * as yup from "yup";

const number = /^[0-9]+$/


export const payment = yup.object().shape({
  amount: yup.string().matches(number, "Amount must be a number.").required("Amount is required").typeError('Amount must be a number'),
  phoneNumber: yup.string().min(11, 'Must be 11 digits').max(11, 'Must be 11 digits').matches(number, "Phone number must be a number.").required("Sender's Phone number is required"),
 
});
